'use client'

import React from 'react'

import { MButton, M_BUTTON_VARIANT_ENUM } from '../../../../components/button'
import { cn } from '../../../../utils/cn'

import type { IButtonProps } from '../../../../components/button/m-button'

export interface IHeroAButtonsProps {
	buttons: IButtonProps[]
	className?: string
}

export const HeroAButtons: React.FC<IHeroAButtonsProps> = ({ buttons, className }) => {
	if (buttons.length === 0) return null
	return (
		<div className={cn('m-hero-a__buttons', className)}>
			{buttons.map((btn, i) => (
				<MButton
					key={i}
					{...btn}
					color={btn.color}
					variant={btn.variant ?? M_BUTTON_VARIANT_ENUM.SOLID}
				/>
			))}
		</div>
	)
}

HeroAButtons.displayName = 'AHeroAButtons'
